import { NgModule } from '@angular/core';
import { UnauthorizedComponent } from 'app/core/authorization/unauthorized/unauthorized.component';

@NgModule({
  declarations: [UnauthorizedComponent],
  exports: [UnauthorizedComponent],
})
export class UnauthorizedModule {}
